/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AppConfigProvider } from './context/AppConfigContext';
import { AuthUserProvider } from './context/AuthUserContext';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <AppConfigProvider>
    <AuthUserProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthUserProvider>
  </AppConfigProvider>
);
